import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  user;
  userNotifications;
  constructor(private userService: UserService, private notificationsService: NotificationsService) {}

  ngOnInit() {
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.user = u;
          this.notificationsService.getUserNotifications(this.user.uid).subscribe((n) => {
            this.userNotifications = n;
            this.userNotifications.forEach((notif) => {
              notif['timeAgo'] = this.notificationsService.getHowLongAgo(notif.date.toDate());
            });
          });
        }
      })
    );
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
